import "@callcenter-frontend/style/variables/variables.css"
import "./styles/application.pcss"
import "@callcenter/design-system/font.css"
import "@callcenter/design-system/style.css"
import { AppInitializer, applyStaticMetaTags, mountLayout } from "@callcenter-frontend/app-initializer"
import "@callcenter-frontend/support-chat"

import { ADMIN_APP_KEYS, APPS } from "./blocks"
import { AUTHORIZATION_PAGES, setupWebAppServices } from "./app-services"
import { initResizeObserverPatcher } from "./patcher/resizeObserverPatcher"
import "./analytics.model"

applyStaticMetaTags()
mountLayout({ adminAppKeys: ADMIN_APP_KEYS })
window.global = window
initResizeObserverPatcher()

const appInitializer = new AppInitializer(APPS, {
  showContentAfterLoadChunk: true
})

const onLoad = async () => {
  const pageNames = appInitializer.elements.map(({ key }) => key)

  if (pageNames.includes("campaigns")) {
    pageNames.push("virtual-users")
  }

  const blockReason = await setupWebAppServices(pageNames, appInitializer)

  if (blockReason) {
    if ((AUTHORIZATION_PAGES as unknown as Array<string>).includes(blockReason)) {
      await appInitializer.initNotifications()
    }

    return
  }

  await appInitializer.initNotifications()
}

document.addEventListener("DOMContentLoaded", onLoad)

if (IS_TESTING_CLUSTER) {
  const setupJsxPatcher = async () => {
    const module = await import(/* webpackChunkName: "JsxPatcher" */ "./patcher/jsxPatcher")

    module.dataTestGenerator()

    module.initJsxPatcher()
  }

  setupJsxPatcher()
}
